import { FC } from "react";

import { Stack } from "@mui/material";

import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface RatingCardProps {
  emoji: string;
  label: string;
  isSelected: boolean;
  onSelect: () => void;
  "data-test"?: string;
}

export const RatingCard: FC<RatingCardProps> = ({ emoji, label, isSelected, onSelect, "data-test": dataTest }) => (
  <Stack
    component="button"
    type="button"
    spacing={0.5}
    alignItems="center"
    justifyContent="center"
    aria-label={label}
    aria-pressed={isSelected}
    data-test={dataTest}
    onClick={onSelect}
    sx={(theme) => ({
      flex: 1,
      minWidth: 0,
      px: 1,
      py: 1.5,
      font: "inherit",
      border: `1px solid ${theme.palette.border.neutral.quiet}`,
      borderRadius: theme.radius(1),
      bgcolor: theme.palette.surface.neutral.white,
      color: theme.palette.text.neutral.quiet,
      cursor: "pointer",
      ...(isSelected && {
        bgcolor: theme.palette.surface.brand.intense,
        borderColor: theme.palette.border.brand.moderate,
        color: theme.palette.text.reverse.intense,
      }),
      ...(!isSelected && {
        "&:hover": {
          bgcolor: theme.palette.surface.neutral.supershy,
          borderColor: theme.palette.border.neutral.intense,
          color: theme.palette.text.neutral.moderate,
        },
      }),
      "&:focus-visible": { outline: `3px solid ${theme.palette.border.brand.moderate}` },
    })}
  >
    <DashboardTypography
      component="span"
      aria-hidden
      sx={(theme) => ({ fontSize: theme.typography.h4.fontSize, lineHeight: theme.typography.h4.lineHeight })}
    >
      {emoji}
    </DashboardTypography>
    <DashboardTypography
      component="span"
      variant="caption"
      sx={{ color: "inherit", maxWidth: "100%", overflowWrap: "anywhere" }}
    >
      {label}
    </DashboardTypography>
  </Stack>
);
